import { createContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { initialState } from '../constants/chart-state.js';
import { HistogramChartState } from '../types/state.js';

export const HistogramChartStateContext = createContext<
  Store<HistogramChartState>
>(createStore<HistogramChartState>(initialState));

HistogramChartStateContext['displayName'] = 'HistogramChartStateContext';
